import secureStorage from 'hooks/secureStorage';

export const User = {
  /**
   * List of different PAMOFOR Users
   */
  Roles: {
    ADMIN: 'ADMIN',
    ENQUETEUR: 'ENQUETEUR',
    VALIDATEUR: 'VALIDATEUR',
  },

  /**
   * return the role of connected user
   * @returns {String}
   */
  get_user_role: () => {
    return secureStorage.getItem('user_role');
  },

  /**
   * Check if the connected user can access to specified ressource.
   * Provide the list of allowed users in array []
   * @param {Array} UserListe
   * @returns {boolean}
   */
  is: (UserListe) => {
    return UserListe?.includes(secureStorage.getItem('user_role'));
  },
};

/**
 * Constante globale au projet
 * Animation de chargement de page
 */
export const loaderStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

/**
 * Constante globale au projet
 * Type de pièces d'identités
 * CNI || Passeport || attestation || Permis || Autres
 */
export const cinOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'CNI', value: 'CIN' },
  { label: 'PASSEPORT', value: 'PASSPORT' },
  { label: 'CARTE CONSULAIRE', value: 'CONSULAIRE' },
  { label: "ATTESTATION D'IDENTITE", value: 'ATTESTATION' },
  { label: 'PERMIS DE CONDUIRE', value: 'PERMIS' },
  { label: 'AUTRES', value: 'AUTRES' },
];

export const sexeOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Femme', value: 'F' },
  { label: 'Homme', value: 'H' },
];

export const OFDOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'CGEDS', value: 'CGEDS' },
  { label: '2ATY', value: '2ATY' },
];

export const documentFoncierOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Certificat foncier', value: 'Certificat foncier' },
  { label: 'Titre foncier', value: 'Titre foncier' },
  { label: 'Titre de concession', value: 'Titre de concession' },
  { label: 'Lettre d’attribution', value: 'Lettre d’attribution' },
  { label: 'Autre document officiel', value: 'Autre document officiel' },
];

export const roleSocialOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Chef de village', value: 'Chef de village' },
  {
    label: 'Représentant du Chef de village',
    value: 'Représentant du Chef de village',
  },
  { label: 'Chef de terres', value: 'Chef de terres' },
  {
    label: 'Représentant du chef de terres',
    value: 'Représentant du chef de terres',
  },
  {
    label: 'Représentant des allochtones',
    value: 'Représentant des allochtones',
  },
  { label: 'Représentant des allogènes', value: 'Représentant des allogènes' },
  { label: 'Notable', value: 'notable' },
  { label: 'Dignitaire religieux', value: 'Dignitaire religieux' },
  {
    label: 'Représentante ou présidente des femmes',
    value: 'Représentante ou présidente des femmes',
  },
  {
    label: 'Représentant ou président des jeunes',
    value: 'Représentant ou président des jeunes',
  },
  { label: 'SG cvgfr', value: 'SG cvgfr' },
  { label: 'SG adjoint cvgfr', value: 'SG adjoint cvgfr' },
  { label: 'Autre', value: 'Autre' },
];

export const categoriesActeursOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'SOUS-PREFET', value: 'SOUS-PREFET' },
  { label: 'COORDINATEUR REGIONAL', value: 'COORDINATEUR REGIONAL' },
  { label: 'COORDINATEUR DEPARTEMENTAL', value: 'COORDINATEUR DEPARTEMENTAL' },
  {
    label: 'CHEF DE BUREAU SOUS-PREFECTORAL',
    value: 'CHEF DE BUREAU SOUS-PREFECTORAL',
  },
  { label: 'COMMISSAIRE-ENQUETEUR', value: 'COMMISSAIRE-ENQUETEUR' },
  { label: 'AGENT ENQUETEUR', value: 'AGENT ENQUETEUR' },
  { label: 'AGENT ISF', value: 'AGENT ISF' },
  {
    label: 'SECRETAIRE ADMINISTRATIF DU SOUS-PREFET',
    value: 'SECRETAIRE ADMINISTRATIF DU SOUS-PREFET',
  },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const lieuOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'PLACE PUBLIQUE', value: 'PLACE PUBLIQUE' },
  { label: 'COUR DU CHEF DE VILLAGE', value: 'COUR DU CHEF DE VILLAGE' },
  {
    label: 'SOUS L’ARBRE A PALABRE DU VILLAGE',
    value: 'SOUS L’ARBRE A PALABRE DU VILLAGE',
  },
  { label: 'ECOLE PRIMAIRE DU VILLAGE', value: 'ECOLE PRIMAIRE DU VILLAGE' },
  { label: 'COLLEGE DU VILLAGE', value: 'COLLEGE DU VILLAGE' },
  { label: 'AUTRE', value: 'AUTRE' },
];

export const fonctionOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Président CVGFR', value: 'Président CVGFR' },
  { label: 'Vice-président CVGFR', value: 'Vice-président CVGFR' },
  { label: 'Secrétaire CVGFR', value: 'Secrétaire CVGFR' },
  { label: 'Secrétaire Adjoint CVGFR', value: 'Secrétaire Adjoint CVGFR' },
  { label: 'Trésorier CVGFR', value: 'Trésorier CVGFR' },
  { label: 'Trésorier Adjoint CVGFR', value: 'Trésorier Adjoint CVGFR' },
  { label: 'Président des jeunes', value: 'Président des jeunes' },
  { label: 'Président des femmes', value: 'Président des femmes' },
  { label: 'Membre CVGFR', value: 'Membre CVGFR' },
  { label: 'Chef du Village', value: 'Chef du Village' },
  { label: 'Chef de Terre', value: 'Chef de Terre' },
  { label: 'Membre Chefferie', value: 'Membre Chefferie' },
  { label: 'Notable', value: 'Notable' },
  { label: 'Guide religieux', value: 'Guide religieux' },
  { label: 'Président de mutuelle', value: 'Président de mutuelle' },
  { label: 'Autre', value: 'Autre' },
];

export const qualiteOptionsList = [
  { label: 'Choisir', value: '' },
  { label: 'Président CVGFR', value: 'Président CVGFR' },
  { label: 'Vice-président CVGFR', value: 'Vice-président CVGFR' },
  { label: 'Secrétaire CVGFR', value: 'Secrétaire CVGFR' },
  { label: 'Secrétaire Adjoint CVGFR', value: 'Secrétaire Adjoint CVGFR' },
  { label: 'Trésorier(ere) CVGFR', value: 'Trésorier(ere) CVGFR' },
  { label: 'Trésorier(ere) Adjoint CVGFR', value: 'Trésorier(ere) Adjoint CVGFR' },
  { label: 'Membre CVGFR', value: 'Membre CVGFR' },
  { label: 'Autre', value: 'Autre' },
];

export const serviceOptionsList = [
  { label: 'CERTIFICATION FONCIÈRE', value: 'DCF' },
  // { label: "CONTRATS", value: "CONTRATS" },
];

export const csvNationalitesPath = '../donnees/nationalites.csv';

export const CommissaireEnq = {
  Signature:
    secureStorage.getItem('signature_com_enq') &&
    secureStorage.getItem('signature_com_enq') !== 'undefined' &&
    secureStorage.getItem('signature_com_enq') !== 'null' ? (
      <div className="flex flex-col px-3 items-end justify-center w-full">
        <img
          className="object-scale-down h-15 w-15"
          src={secureStorage.getItem('signature_com_enq')}
          alt="Signature commissaire Enq"
        />
      </div>
    ) : null,
};

export const CommissaireEnqSignature =
  secureStorage.getItem('signature_com_enq') || null;

export const MESSAGES = {
  SUCCESS: 'RESSOURCE CREEE AVEC SUCCES',
  CONFIRMATION_TRANSMISSION: 'La ressource a été transmise avec succès.',
  ERROR_TRANSMISSION: "une erreur s'est produite.",
  SEND: "CONFIRMER L'ENVOI ?",
  SEND_TRANSMISSION: 'Êtes-vous sûr de vouloir transmettre cette demande?',
  SEND_TRANSMISSION_ENQUETE:
    'Êtes-vous sûr de vouloir transmettre cette enquete?',
  ERROR: "UNE ERREUR S'EST PRODUITE, VOTRE REQUETE N'A PAS ABOUTI",
  LOADIND: 'REQUETE EN COURS..., VEUILLEZ PATIENTEZ',
  QUIT: 'VOULEZ-VOUS QUITTER ?',
  CONFIRMATION_SUPPRESSION: 'VOULEZ-VOUS SUPPRIMER CETTE RESSOURCE ?',
  SIGNATURE_MODIFICATION:
    ' ENREGISTREMENT AVEC SUCCES, SUITE A CETTE MODIFICTION VOTRE SIGNATURE SERA AFFECTEE AU LIVRABLE',
};

export const MSG_CF = {
  CREATE: "Confirmer l'enregistrement ?",
  CREATE_INPART: (
    <>
      <div className="flex flex-col gap-5 items-center justify-start w-full">
        <div className="flex flex-col items-center justify-start w-full">
          <p
            className="text-cyan-900 text-center text-base w-full"
            size="txtInterRegular"
          >
            L'annonce de publicité sera créée avec seulement les demandes ayant
            la résidence renseignée.
          </p>
          <br />
          <p
            className="text-blue_gray-800_01 text-left text-base w-full"
            size="txtInterRegular"
          >
            Si vous voulez continuer, Confirmer l'enregistrement.
          </p>
          <p
            className="text-blue_gray-800_01 text-left text-base w-full"
            size="txtInterRegular"
          >
            Sinon, Annuler et quitter pour renseigner les informations de
            résidence sur les demandes concernées. Puis revenir à nouveau pour
            créer l'annonce de publicité.
          </p>
        </div>
      </div>
    </>
  ),
  // CREATE_INPART:
  //   "L'annonce de publicité sera créée avec seulement les demandes ayant la résidence renseignée.\n\n" +
  //   "Si vous voulez continuer, Confirmer l'enregistrement.\n\n" +
  //   "Sinon, Annuler et quitter pour renseigner les informations de résidence sur les demandes concernées. Puis revenir à nouveau pour créer l'annonce de publicité.",
  ADDITIONAL_DCF: 'Voulez-vous ajouter la liste des nouvelles demandes ?',
  CONFIRM_PVPUB:
    'Tous les champs sont correctement renseignés.\n\n' +
    'Quittez cette fenêtre et cliquez sur le bouton Enregistrer pour enregistrer le PV de clôture de publicité.',
  ERROR:
    "Erreur survenue. Veuillez contacter l'administrateur ou réessayer plus tard!",
  ERROR_QUIT:
    "Livrable enregistré mais tous les éléments de la liste annexe n'ont pas été bien enregistrés. Veuillez contacter l'administrateur ou réessayer plus tard!",
  QUIT: 'Voulez-vous quitter sans enregistrer? Toutes les informations saisies seront perdues!',
};
